<template>
    <v-app style="background-color: #f3f6f9">
        <v-main>
           
            <PlansComp />

        </v-main>
    </v-app>
</template>
<script>
import Auth from '@/services/auth.service.js'
import PlansComp from '@/components/admin/plans/PlansComp.vue'

export default {
    components: {
        PlansComp,
    },
    data() {
        return {
        };
    },
    methods: {
    },
    computed: {
    },
    mounted() {
        document.title = 'חבילות | סים לחומרא'
        let auth = Auth.checkAuth();
        if (!auth) {
            return this.$router.replace({ name: "login" })
        }
    },
}
</script>
<style>
</style>